import { createApp } from "vue";
import App from "./App.vue";

document.documentElement.classList.add("loading");

const app = createApp(App);

app.mount("#app");
